<template>
  <div id="app">
    <Header />
    <AboutUs />
    <Services />
    <CategoriesSlider />
    <Questions />
  </div>
</template>

<script>
import Header from "../Components/Header.vue";
import AboutUs from "../Components/AboutUs.vue";
import Services from "../Components/Services.vue";
import CategoriesSlider from "../Components/CategoriesSlider.vue";
import Questions from "../Components/Questions.vue";

export default {
  name: "App",
  components: {
    Header,
    AboutUs,
    Services,
    CategoriesSlider,
    Questions
  },
};
</script>

<style>
</style>
